var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"main":"agent.resource","title":"agent.header"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid search-page"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6"})])])
}]

export { render, staticRenderFns }